export default {
  "content": "<path d=\"M12.793 14.207L18.586 20H14.5v2H21a1 1 0 001-1v-6.5h-2v4.086l-5.793-5.793-1.414 1.414zM4 3a1 1 0 00-1 1v6.5h2V6.414l5.793 5.793 1.414-1.414L6.414 5H10.5V3H4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};